import { Grid, Typography } from "@mui/material";
import FormField from "../../../../components/common/FormField";

import { completionFields } from "./completionAllFields";
import { useEffect, useMemo, useState } from "react";
import CustomButton from "../../../../components/common/button/CustomButton";
import { updateCrewLeadNotesAction } from "../../../../store/reducers/reviewSlice";
import { useDispatch } from "react-redux";

interface CompletionFormProps {
  singleLeadCompletionNotes: any; // Replace 'any' with the appropriate type
}

const CompletionForm: React.FC<CompletionFormProps> = ({
  singleLeadCompletionNotes,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const dispatch = useDispatch();
  const normalizedNotes = useMemo(
    () => singleLeadCompletionNotes?.notes || singleLeadCompletionNotes || {},
    [singleLeadCompletionNotes],
  );
  const [notes, setNotes] = useState(normalizedNotes?.crew_notes || "");

  console.log("Normalized Notes", normalizedNotes);
  console.log("Single Lead Completion Notes", singleLeadCompletionNotes);
  useEffect(() => {
    setNotes(normalizedNotes?.crew_notes || "");
    setIsEdit(false);
  }, [
    normalizedNotes?.crew_notes,
    singleLeadCompletionNotes?.quote_id,
    singleLeadCompletionNotes?.quoteId,
  ]);

  const getDisplayValue = (value: any) => {
    if (value === null || value === undefined) {
      return "NA";
    }

    return String(value).trim() === "" ? "NA" : value;
  };

  const handleEdit = () => {
    setIsEdit(true);
  };

  const handleSave = () => {
    const payload = {
      crew_notes: notes,
      crew_id: normalizedNotes?.crew_id ?? null,
    };

    console.log("Submit Data", payload);

    // dispatch API here
    dispatch(updateCrewLeadNotesAction(payload));

    setIsEdit(false);
  };

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    if (id === "crew_notes") {
      setNotes(value);
    }
  };

  return (
    <div
      style={{
        padding: "10px 20px 10px 20px",
        border: "1px solid #CFCFCF",
        borderRadius: "5px",
        overflow: "hidden",
        backgroundColor: "#E5F4F1",
      }}
    >
      <Typography variant="subtitle2" fontWeight={700}>
        Notes
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{
          padding: "10px",
          mt: 1,
        }}
        // direction="column"
        // justifyContent="center"
        // alignItems="center"
      >
        <Grid
          item
          md={12}
          xs={12}
          sx={{ padding: "10px 0px 10px 0px !important" }}
        >
          <Grid container spacing={2}>
            {completionFields.map((field) => {
              // Only hide crew_notes when it is null
              if (
                field.id === "crew_notes" &&
                normalizedNotes?.crew_id === null
              ) {
                return null;
              }

              return (
                <FormField
                  // disabled
                  onPaste={(e) => e.preventDefault()}
                  onKeyDown={(event: any) => {
                    if (
                      event.keyCode === 8 ||
                      event.keyCode === 9 ||
                      event.keyCode === 37 ||
                      event.keyCode === 38 ||
                      event.keyCode === 39 ||
                      event.keyCode === 40 ||
                      event.keyCode === 18 ||
                      event.keyCode === 17 ||
                      event.ctrlKey
                    )
                      return event;
                    if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.key)
                    ) {
                      event.preventDefault();
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(
                        event.target.value + event.key,
                      )
                    ) {
                      event.preventDefault();
                    }
                  }}
                  {...{
                    ...field,
                    //   value: workerDetails ? workerDetails?.count : 0,
                    value:
                      field.id === "crew_notes"
                        ? notes
                        : getDisplayValue(normalizedNotes?.[field?.id]),
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    inSingleGridForm: true,
                    // multiline: true,
                    disabled: field.id === "crew_notes" ? !isEdit : true,
                    onChange: onChangeAction,
                    //   onBlur: onBlurWorkerAction,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? {
                              height: "36px",
                            }
                          : {
                              padding: "10px 4px",
                              height: "auto",
                            },
                    },
                  }}
                />
              );
            })}
          </Grid>
        </Grid>

        {/* Buttons */}
        {normalizedNotes?.crew_id !== null && (
          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
            {!isEdit ? (
              <CustomButton
                variant={"contained"}
                title="Edit"
                onClick={handleEdit}
              />
            ) : (
              <CustomButton
                variant={"contained"}
                title="Save"
                onClick={handleSave}
              />
            )}
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default CompletionForm;
